<template>
  <div class="login-wrapper">
    <div class="titleWrapper">
      <img src="../assets/logo.png" class="logo" alt="">
      <div class="title">BASI管理平台</div>
    </div>
    <div class="login-panel">
      <el-input
        placeholder="请输入手机号"
        prefix-icon="el-icon-user-solid"
        maxlength="11"
        v-model="phone">
      </el-input>
      <div class="space"></div>
      <el-row>
        <el-col :span="15">
          <div class="grid-content">
            <el-input
              placeholder="请输入短信验证码"
              prefix-icon="el-icon-s-claim"
              v-model="code">
            </el-input>
          </div>
        </el-col>
        <el-col :span="9" style="width: 115px;">
          <div class="grid-content">
            <el-button
              type="primary"
              class="login-btn"
              :disabled="disabled"
              @click="getCode"
            >{{btnText}}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <div class="space"></div>
      <el-button
        type="primary"
        class="login-btn"
        @click="doLogin"
      >登录
      </el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { isPhoneNo } from '@/common/js/util';
  import { getCode, login } from '@/api/user';
  import { mapMutations } from 'vuex';

  export default {
    name: 'Login',
    data() {
      return {
        phone: '',
        code: '',
        token: '',
        disabled: false,
        btnText: '发送验证码'
      };
    },
    methods: {
      doLogin() {
        if (this.phone === '') {
          this.$message.warning('手机号不能为空！');
          return;
        }
        if (!isPhoneNo(this.phone)) {
          this.$message.warning('请输入正确的手机号！');
          return;
        }
        if (this.code === '') {
          this.$message.warning('短信验证码不能为空！');
          return;
        }
        login(this.phone, this.token, this.code).then((res) => {
          if (res.rspCode === 0) {
            let user = {
              userId: res.userId,
              userName: res.userName,
              phoneNo: this.phoneNo,
              toDoList: res.toDoList
            };
            this.setUser(user);
            localStorage.setItem('userId', res.userId);
            localStorage.setItem('phoneNo', this.phoneNo);
            this.$router.push('/');
          } else {
            this.$message.error(res.rspDesc);
          }
        });
      },
      getCode() {
        if (this.phone === '') {
          this.$message.warning('手机号不能为空！');
          return;
        }
        if (!isPhoneNo(this.phone)) {
          this.$message.warning('请输入正确的手机号！');
          return;
        }
        getCode(this.phone).then((res) => {
          if (res.rspCode === 0) {
            this.disabled = true;
            this.token = res.token;
            let time = 60;
            time--;
            this.btnText = `${time}秒后重发`;
            let timer = setInterval(() => {
              time--;
              this.btnText = `${time}秒后重发`;
              if (time < 0) {
                clearInterval(timer);
                this.disabled = false;
                this.btnText = '发送验证码';
              }
            }, 1000);
          } else {
            this.$message.error(res.rspDesc);
          }
        });
      },
      ...mapMutations({
        setUser: 'SET_USER'
      })
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .login-wrapper
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .titleWrapper {
      margin-bottom: 20px;
      display: flex;
      .logo {
        height: 80px;
        width: 80px;
      }
      .title {
        margin-left: 10px;
        line-height: 80px;
        font-size: 30px;
        font-weight: bold;
        color: #333;
      }
    }
    .space
      height: 20px;
      width: 100%;
    .login-panel
      padding: 50px 40px;
      background: #fff;
      border-radius: 4px;
    .login-btn
      width: 100%
</style>